import { z } from 'zod'

export type TeenagerProcessType = {
  numeroCnj: string
  numeroVemse: string
  tipoMedidaSocioeducativa: string
  processoIntegraPolicialId?: number | null
  oitivaId?: number | null
  meioAbertoId?: number | null
  creas?: { id: number; nome: string }
  origem: string
  podeVisualizar: boolean
}

export const TeenagerProcessFilterSchema = z.object({
  numeroCnj: z.string().nullish(),
  numeroVemse: z.string().nullish(),
  tipoMedidaSocioeducativa: z.string().nullish(),
  creas: z.number().nullish(),
  status: z.string().nullish(),
})

export type TeenagerProcessFilterType = z.infer<typeof TeenagerProcessFilterSchema>

export const TeenagerProcessFilterInit: TeenagerProcessFilterType = {}
